<template>
  <div>
    <nav-bar fixed z-index="99" title="测评结果" left-text="返回" left-arrow placeholder @click-left="$router.go(-1)"
      right-text="个人中心" @click-right="$router.push('/user')" />
    <div class="evaluation-result">
      <div class="evaluation-result-head" :style="`background-image: url(${headerImg});`">
        <div class="evaluation-result-head-title">
          蒲公英青少年全人发展 生态系统测评
        </div>
      </div>
      <div class="evaluation-result-content">
        <div ref="resultRef">
          <EvaluationBox class="evaluation-result-content-item" title="测评结果与解读" v-if="reviewResult.tag !== false">
            <ul class="evaluation-result-content-interpret">
              <li class="evaluation-result-content-interpret-item" v-for="(item, index) in reviewResult.content"
                :key="index">
                <span class="evaluation-result-content-interpret-item-title">{{ item.dimensionName }}:</span>
                <span v-html="item.result"></span>
              </li>
            </ul>
          </EvaluationBox>

          <EvaluationBox class="evaluation-result-content-item" title="测评报告" v-if="reviewResult.tag !== false">
            <RadarEchart v-if="xData.length > 4" :xData="xData" :values="values" />

            <barEchartVue v-else :xData="xData" :values="values" />

            <div style="color: #333; font-size: 0.2rem">
              基准值的设置参考了权威文献，并结合实际评测大数据进行动态调整，反应了平均情况。
            </div>
          </EvaluationBox>

          <EvaluationBox class="evaluation-result-content-item">
            <template #title>
              <div>
                关于
                <span style="font-size: 0.35rem">{{
      reviewResult.cateName || "未知"
    }}</span>
                的建议
              </div>
            </template>
            <div>
              <div class="html-content" v-html="reviewResult.reviewSuggest"></div>
              <div class="html-content" v-html="reviewSuggest"></div>
            </div>
          </EvaluationBox>
        </div>

        <EvaluationBox class="evaluation-result-content-item" title="1对1家庭教练深度解读与支持">
          <div>
            <div class="evaluation-result-content-item-suppot">
              <div v-if="supportList[1]" class="html-content" style="margin-bottom: 0.4rem" v-html="supportList[0]">
              </div>

              <div class="evaluation-result-content-item-suppot-coach">
                <VanImage class="evaluation-result-content-item-suppot-coach-avatar" width="1.5rem" height="1.5rem"
                  round :src="coachData.storeInfo.image" />
                <div class="evaluation-result-content-item-suppot-coach-content">
                  <div class="evaluation-result-content-item-suppot-coach-content-info">
                    <div class="evaluation-result-content-item-suppot-coach-content-info-des">
                      <span class="evaluation-result-content-item-suppot-coach-content-info-des-name">{{
      coachData.storeInfo.storeName }}</span>
                      <span class="evaluation-result-content-item-suppot-coach-content-info-des-price">{{
      $store.state.app.dictObj.first_price }}元首约</span>
                    </div>
                    <div class="evaluation-result-content-item-suppot-coach-content-info-change" @click="getCoachData">
                      <Icon name="replay" size="20" color="#fff" />
                      <div>换一位</div>
                    </div>
                  </div>

                  <ul class="evaluation-result-content-item-suppot-coach-content-tags">
                    <li v-for="item in coachZone">{{ item }}</li>
                  </ul>
                </div>
              </div>

              <div v-if="supportList[1]" class="html-content" style="margin-top: 0.4rem" v-html="supportList[1]"></div>
              <div v-else class="html-content" style="margin-top: 0.4rem" v-html="supportList[0]"></div>

              <div class="evaluation-result-content-item-suppot-apply" @click="goApply">
                立即预约
              </div>
            </div>
          </div>
        </EvaluationBox>

        <EvaluationBox class="evaluation-result-content-item" title="你觉得测评有帮助吗？">
          <div class="evaluation-result-content-item-comment" v-if="reviewResult.isReply != 1">
            <Rate v-model="form.rateValue" :size="20" color="#ffd21e" void-icon="star" void-color="#eee" />
            <textarea class="evaluation-result-content-item-comment-input" v-model="form.replyContent" name="" id=""
              cols="30" rows="3"></textarea>
            <div class="evaluation-result-content-item-comment-bottom">
              <div class="evaluation-result-content-item-comment-bottom-btn" @click="publish(1)">
                匿名发布
              </div>
              <div style="margin-left: 0.2rem" class="evaluation-result-content-item-comment-bottom-btn"
                @click="publish(0)">
                发布
              </div>
            </div>
          </div>
          <div class="evaluation-result-content-item-comment" v-else>
            <Rate v-model="reviewResult.replyScore" readonly :size="20" color="#ffd21e" void-icon="star"
              void-color="#eee" />
            <textarea class="evaluation-result-content-item-comment-input" disabled :value="reviewResult.replyContent"
              name="" id="" cols="30" rows="3"></textarea>
            <div class="evaluation-result-content-item-comment-bottom"></div>
          </div>
        </EvaluationBox>
      </div>

      <div class="evaluation-result-self">
        <span class="evaluation-result-self-text" @click="$router.push('/evaluation/my')">我的测评</span>
      </div>

      <div class="evaluation-result-footer">
        <div class="evaluation-result-footer-start" @click="saveResult">
          一键保存测评报告
        </div>
      </div>

      <Overlay :show="showSave">
        <div class="evaluation-overlay-content">
          <div class="evaluation-overlay-content-box">
            <div class="evaluation-overlay-content-box-img scrollbar">
              <img style="width: 100%" :src="imgData" />
            </div>
            <div class="evaluation-overlay-content-box-text">
              长按上方图片保存到相册
            </div>

            <div class="evaluation-overlay-content-box-close" @click="showSave = false">
              x
            </div>
          </div>
        </div>
      </Overlay>
    </div>
  </div>
</template>

<script>
import EvaluationBox from "@/components/evaluation/EvaluationBox.vue";
import RadarEchart from "@/components/echarts/src/radar-echart.vue";
import barEchartVue from "@/components/echarts/src/bar-echart.vue";
import { Rate, Image as VanImage, Icon, NavBar, Overlay } from "vant";
import { getSystemConfig } from "@/api/public";
import {
  getReviewResult,
  getProductDetail,
  getProductRandomId,
  orderReply,
  getReviewConfig,
} from "@/api/evaluation";
import html2canvas from "html2canvas";
import { getCategory } from "@api/store";
export default {
  data() {
    return {
      headerImg: "",
      reviewSuggest: "",
      form: {
        rateValue: 4,
        replyContent: "",
      },
      xData: [],
      values: [],
      coachData: {
        storeInfo: {},
      },
      zone: [],
      // 当前随机教练所属领域
      coachZone: [],
      reviewResult: {
        replyScore: 1,
      },
      reviewConfig: {},
      supportList: [],
      coachIdList: [],
      imgData: "",
      showSave: false,
    };
  },
  components: {
    EvaluationBox,
    Rate,
    VanImage,
    Icon,
    RadarEchart,
    barEchartVue,
    NavBar,
    Overlay,
  },
  mounted() {
    this.getSystemConfig();
    this.getCategory();
    this.getReviewResult();
    this.getReviewConfig();
    this.getCoachIdList().then(() => {
      this.getCoachData();
    });
    let list = document.querySelector(".scrollbar");
    list.addEventListener("touchmove", (e) => e.stopPropagation(), false);
  },
  methods: {
    // 获取头部图片配置
    getSystemConfig() {
      getSystemConfig({ name: "evaluation_header_img" }).then((res) => {
        this.headerImg = res.data;
      });
      getSystemConfig({ name: "review_suggest" }).then((res) => {
        this.reviewSuggest = res.data;
      });
    },
    // 获取评分结果
    getReviewResult() {
      const data = {
        orderId: this.$route.query.orderId,
      };
      getReviewResult(data).then((res) => {
        this.reviewResult = res.data;
        const list = JSON.parse(res.data.content);
        if (this.reviewResult.isOpenSection == 1) {
          const reviewResultContent = [];
          // 展示list中的item中socre分数最大的前三个
          // 先进行排序
          list.sort((a, b) => b.score - a.score);
          for (let i = 0; i < this.reviewResult.dimensionNum; i++) {
            if (list[i]) {
              reviewResultContent.push(list[i]);
            }
          }
          this.reviewResult.content = reviewResultContent;
        } else {
          this.reviewResult.content = list;
        }
        // this.reviewResult.content = list;
        if (list.length > 4) {
          this.xData = list.map((item) => {
            const score = item.score || 0;
            const max = item.dimensionAvg || 0;
            return {
              name: item.dimensionName,
              max: max + 10,
            };
          });
          this.values[0] = {
            value: list.map((item) => item.score || 0),
            name: "评测值",
          };
          this.values[1] = {
            value: list.map((item) => item.dimensionAvg || 0),
            name: "基准值",
          };
        } else {
          this.values[0] = {
            name: "评测值",
            type: "bar",
            data: list.map((item) => item.score || 0),
            emphasis: {
              focus: "series",
            },
            itemStyle: { color: "rgb(255,200,55)" },
          };
          this.xData = list.map((item) => item.dimensionName);
          this.values[1] = {
            type: "bar",
            name: "基准值",
            data: list.map((item) => item.dimensionAvg || 0),
            emphasis: {
              focus: "series",
            },
            itemStyle: { color: "rgb(47, 69, 84)" },
          };
        }

        // console.log(JSON.parse(res.data.content));
      });
    },
    // 获取教练领域
    getCategory() {
      getCategory().then((res) => {
        if (res.success) {
          this.zone = res.data;
        }
      });
    },
    // 获取所有教练ID，用于随机教练
    async getCoachIdList() {
      // const res = await getProductRandomId();
      // this.coachIdList = res.data;
      // return Promise.resolve();
      return new Promise((resolve) => {
        getProductRandomId().then((res) => {
          this.coachIdList = res.data;
          resolve();
        });
      });
    },
    // 获取随机教练
    getCoachData() {
      this.$dialog.loading.open("教练加载中");
      if (this.coachIdList.length === 0) {
        this.getCoachIdList().then(() => {
          this.getCoachData();
        });
        return;
      }

      const coachId = this.coachIdList.shift();
      getProductDetail(coachId)
        .then((coach) => {
          this.coachData = coach.data;
          this.changeCoachZone();
        })
        .finally(() => {
          this.$dialog.loading.close();
        });
    },
    changeCoachZone() {
      const cateIds = this.coachData.storeInfo.cateId.split(",");
      const coachList = this.zone.filter((item) =>
        cateIds.includes(item.id.toString())
      );
      this.coachZone = [
        ...coachList.map((item) => item.cateName),
        ...this.coachData.storeInfo.keyword.split(","),
      ];
    },
    // 发布评分
    publish(type) {
      const data = {
        orderId: this.$route.query.orderId,
        replyContent: this.form.replyContent,
        replyScore: this.form.rateValue,
        isAnonymity: type,
      };
      orderReply(data).then((res) => {
        this.$toast.success("发布成功");
        // this.getReviewResult();
        this.reviewResult.isReply = 1;
        this.reviewResult.replyContent = this.form.replyContent;
        this.reviewResult.replyScore = this.form.rateValue;
      });
    },
    getReviewConfig() {
      getReviewConfig().then((res) => {
        this.reviewConfig = res.data;
        this.supportList = res.data.support.split("#{测评教练}");
      });
    },
    goApply() {
      this.$router.push({
        path: `/detail/${this.coachData.storeInfo.id}`,
        query: {
          // 0测评 1私域 2平台
          source: 0,
          reviewOrderId: this.$route.query.orderId,
        },
      });
    },
    // 截取内容，保存测评结果到本地相册
    saveResult() {
      this.$dialog.loading.open("保存中");
      html2canvas(this.$refs.resultRef, {
        backgroundColor: null, //取消图片白边问题
        useCORS: true, //如果是动态加载的图片 获取图片
      })
        .then((canvas) => {
          let dataURL = canvas.toDataURL("image/png");
          // 给base64加上标准前缀
          // this.downloadFile("测评结果.png", dataURL.split(",")[1]);
          this.imgData = dataURL;
          this.showSave = true;
        })
        .finally(() => {
          this.$dialog.loading.close();
        });
    },

    //对外暴露下载接口。
    downloadFile(fileName, content) {
      let aLink = document.createElement("a");
      let blob = this.base64ToBlob(content); //new Blob([content]);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      aLink.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      ); //兼容火狐
    },
    base64ToBlob(code) {
      let contentType = code.split(":")[1];
      let raw = window.atob(code);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
  },
};
</script>

<style lang="scss" scoped>
.evaluation-result {
  background-color: #fff;

  &-head {
    background-image: url("~@/assets/evaluation/header.png");
    height: 2.3rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;

    &-title {
      position: absolute;
      top: 0.97rem;
      left: 0.6rem;
      color: rgb(255, 196, 0);
      font-weight: bold;
      font-family: DINAlternate-Bold;
      font-size: 0.35rem;
      text-wrap: wrap;
      width: 3.5rem;
    }
  }

  &-content {
    padding: 0.2rem 0.3rem;

    &-item {
      margin: 0.3rem 0;

      &-comment {
        &-input {
          border: none;
          outline: none;
          background: none;
          padding: 0.1rem;
          margin: 0.2rem 0;
          // font-size: 1rem;
          width: 100%;
          background: #fff;
          box-shadow: 0 0 0.05rem #ccc;
          border-radius: 0.15rem;
        }

        &-bottom {
          display: flex;
          justify-content: flex-end;
          color: #000;

          &-btn {
            background-color: rgb(255, 200, 55);
            border-radius: 0.5rem;
            padding: 0rem 0.55rem;
            font-size: 0.3rem;
            display: inline-block;
            font-weight: bold;
          }
        }
      }

      &-suppot {
        &-coach {
          display: flex;
          align-items: center;

          &-avatar {
            flex-shrink: 0;
          }

          &-content {
            margin-left: 0.2rem;
            width: 100%;

            &-info {
              display: flex;
              justify-content: space-between;
              align-items: center;

              &-des {
                display: flex;
                flex-direction: column;
                color: #000;
                font-weight: bold;

                &-name {
                  font-size: 0.3rem;
                }

                &-price {
                  font-size: 0.25rem;
                  color: rgb(255, 200, 55);
                }
              }

              &-change {
                display: flex;
                align-items: center;
                background-color: rgb(255, 200, 55);
                font-weight: bold;
                padding: 0.1rem 0.15rem;
                border-radius: 2rem;
                color: #000;

                &>div {
                  margin-left: 0.05rem;
                }
              }
            }

            &-tags {
              display: flex;
              align-items: center;
              margin-top: 0.2rem;
              flex-wrap: wrap;

              &>li {
                background-color: #fff;
                border-radius: 0.1rem;
                font-size: 0.22rem;
                display: inline-block;
                margin: 0.05rem;
                padding: 0 0.15rem;
                text-wrap: wrap;
              }
            }
          }
        }

        &-apply {
          margin: 0.5rem 0;
          background-color: rgb(255, 200, 55);
          border-radius: 0.5rem;
          padding: 0.1rem 0.55rem;
          font-size: 0.3rem;
          width: 100%;
          text-align: center;
          font-weight: bold;
        }
      }
    }

    &-interpret {
      &-item {
        &-title {
          font-weight: bold;
          // color: #000;
          margin-right: 0.2rem;
        }

        font-size: 0.3rem;
        // color: #000;
        margin: 0.2rem 0;
      }
    }
  }

  &-self {
    font-size: 0.25rem;
    color: #666;
    display: flex;
    justify-content: center;
    padding: 0.2rem 0 1.5rem 0;

    &-text {
      text-align: center;
      border-bottom: 0.03rem solid #666;
      padding-bottom: 0.05rem;
    }
  }

  &-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.2rem;
    background-color: rgb(255, 200, 55);
    z-index: 3;
    display: flex;
    align-items: center;
    padding: 0rem 0.3rem;

    &-start {
      width: 100%;
      background-color: #fff;

      font-size: 0.3rem;
      font-weight: bold;
      border-radius: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.35rem;
      padding: 0.1rem 0.35rem;
      color: #000;

      // box-shadow: 3px 3px 7px rgba(0, 0, 0, .4), 1px 1px 1px rgba(255, 255, 255, .9);
      border: 2px solid #ccc;
      box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
    }
  }
}

.evaluation-overlay {

  &-content {
    overflow: hidden;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex-direction: column;
    position: relative;

    &-box {
      padding: 0.1rem;
      border-radius: 0.2rem;
      background-color: white;
      width: 70%;
      position: relative;

      &-img {
        height: 60vh;
        overflow-y: auto
      }

      &-text {
        text-align: center;
        margin-top: 10px;
        color: red;
        font-size: 0.3rem;
        font-bold: bold;
      }

      &-close {
        position: absolute;
        bottom: -0.6rem;
        left: 50%;
        color: white;
        border: 0.05rem solid #fff;
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translateX(-50%);
      }
    }
  }

}


::v-deep .van-nav-bar {
  background-color: rgb(255, 196, 0) !important;
}
</style>
